import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { loanApi } from "../api";
import "../common";
import { BaseResource } from "@kgsport-cms/common";
/***
 * created by 六月
 * 借呗相关接口
 * 2022-04-26
 *
 */
export var LoanService = /*#__PURE__*/function (_BaseResource) {
  _inherits(LoanService, _BaseResource);
  var _super = _createSuper(LoanService);
  function LoanService() {
    _classCallCheck(this, LoanService);
    return _super.apply(this, arguments);
  }
  _createClass(LoanService, [{
    key: "getLoan",
    value:
    // 查询借呗额度
    function getLoan() {
      return this.requester.get(loanApi.getLoan);
    }
    // 借款
  }, {
    key: "lend",
    value: function lend(money) {
      return this.requester.post(loanApi.lend, {
        money
      });
    }
    // 还款
  }, {
    key: "repay",
    value: function repay(money) {
      return this.requester.post(loanApi.repay, {
        money
      });
    }
    // 借款记录
  }, {
    key: "record",
    value: function record(params) {
      return this.requester.get(loanApi.record, {
        params
      });
    }
  }]);
  return LoanService;
}(BaseResource);